/* eslint-disable no-underscore-dangle */
import { useCallback, useEffect } from 'react';
import { useRouter } from '@application/utils';

interface UseRedirectParams {
  currentAccountLoggedIn: boolean;
  breederUrl?: string | null;
}
export const useRedirect = (params: UseRedirectParams) => {
  const { currentAccountLoggedIn, breederUrl } = params;
  const { navigateToRoute, infoFromCurrentPath, setCurrentSearch } = useRouter();
  const onRedirectToWriteReviewPathSearch = useCallback(() => {
    if (currentAccountLoggedIn && breederUrl) {
      navigateToRoute('breederReview', {
        params: [breederUrl as string],
      });
    } else {
      setCurrentSearch({});
    }
  }, [breederUrl, currentAccountLoggedIn, navigateToRoute, setCurrentSearch]);

  useEffect(() => {
    if (infoFromCurrentPath.search?.writeReview === 'true') {
      onRedirectToWriteReviewPathSearch();
    }
  }, [infoFromCurrentPath.search?.writeReview, onRedirectToWriteReviewPathSearch]);
};
